module.exports = __webpack_public_path__ + "img/spfc1.a0aedeb4.jpg";